import { Outlet } from "react-router";
import { useScrollToTop } from "@/common/hooks/useScrollToTop";
import { ModalError } from "@/components/ModalError";
import { Footer } from "@/widgets/Footer";
import { Header } from "@/widgets/Header";

export const LayoutBaseFooter = () => {
  useScrollToTop();

  return (
    <>
      <Header />
      <div className="lgc:gap-[var(--landing-section-gap)] flex flex-col">
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
      <ModalError />
    </>
  );
};
